// import * as React from "react";
// import { toast } from "react-toastify";
// import { Modal, ModalBody } from "reactstrap";
// import {
// 	clientAuditUploadFile,
// 	clientUploadSubmitCheckpointLocation,
// 	vendorFileUpload,
// 	vendorUploadSubmitCheckpointLocation,
// } from "@services/auth.service";
// import { getValue } from "@utils/lodash";
// import "./upload-modal.scss";

// interface IUploadModalProps {
// 	isOpen: boolean;
// 	handleModal: () => void;
// 	getData: () => void;
// 	vendorInfo: object;
// }

// const UploadModal: React.FunctionComponent<IUploadModalProps> = (props) => {
// 	const [isLoading, setIsLoading] = React.useState(false);
// 	const [submitLoading, setSubmitLoading] = React.useState(false);
// 	const [uploadedDocuments, setUploadedDocuments] = React.useState<any>([]);

// 	const handleSubmit = async () => {
// 		try {
// 			setSubmitLoading(true);
// 			let payload = {
// 				vendor_checkpoint: [
// 					{
// 						id: getValue(props, `vendorInfo.id`, ""),
// 						document_ids: uploadedDocuments.map((item: object) =>
// 							getValue(item, `id`, "")
// 						),
// 					},
// 				],
// 				// domain_name: getValue(localStorage,`client`,''),
// 			};
// 			let resp = await clientUploadSubmitCheckpointLocation(payload);
// 			if (resp) {
// 				setSubmitLoading(false);
// 				props.handleModal();
// 				props.getData();
// 				toast.success("Uploaded successfully");
// 			} else {
// 				props.getData();
// 				setSubmitLoading(false);
// 			}
// 		} catch (error) {
// 			setSubmitLoading(false);
// 		}
// 	};

// 	const handleRemoveUploadedFiles = (id: string) => {
// 		let filtered = uploadedDocuments.filter(
// 			(item: object) => getValue(item, `id`, "") !== id
// 		);
// 		setUploadedDocuments(filtered);
// 	};

// 	const [uploadLoading, setUploadLoading] = React.useState(false);
// 	const handleUploadDocuments = async (e: any) => {
// 		e.preventDefault();
// 		Array.from(e.target.files).forEach(async (item: any) => {
// 			let formData = new FormData();
// 			formData.append("file", item);
// 			// formData.append("domain_name", getValue(localStorage,`client`,''));
// 			try {
// 				setUploadLoading(true);
// 				let resp = await clientAuditUploadFile(formData);
// 				if (resp) {
// 					uploadedDocuments.push(getValue(resp, `data`, {}));
// 					setUploadedDocuments([...uploadedDocuments]);
// 					e.target.value = null;
// 					setUploadLoading(false);
// 				} else {
// 					e.target.value = null;
// 				}
// 			} catch (error) {
// 				e.target.value = null;
// 				setUploadLoading(false);
// 			}
// 		});
// 	};
// 	const handleDrop = (e: any) => {
// 		e.preventDefault();
// 		const files = Array.from(e.dataTransfer.files);
// 		files.forEach(async (item: any) => {
// 			let formData = new FormData();
// 			formData.append("file", item);
// 			try {
// 				setUploadLoading(true);
// 				let resp = await clientAuditUploadFile(formData);
// 				if (resp) {
// 					uploadedDocuments.push(getValue(resp, `data`, {}));
// 					setUploadedDocuments([...uploadedDocuments]);
// 					e.target.value = null;
// 					setUploadLoading(false);
// 				} else {
// 					e.target.value = null;
// 				}
// 			} catch (error) {
// 				e.target.value = null;
// 				setUploadLoading(false);
// 			}
// 		});
// 	};
// 	const handleDragOver = (event: any) => {
// 		event.preventDefault();
// 	};
// 	const disableUpload = () => {};

// 	return (
// 		<div className="comments-popup">
// 			<Modal
// 				isOpen={getValue(props, `isOpen`, "")}
// 				toggle={getValue(props, `isOpen`, "")}
// 				centered
// 				size="lg"
// 			>
// 				<div className="comments-modal">
// 					<div className="comments-popup__header d-flex align-items-center justify-content-between mb-3">
// 						<h3 className="comments-popup__header-title">Attach File</h3>
// 						<div className="d-flex justify-content-end">
// 							<button
// 								className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
// 								onClick={() => props.handleModal()}
// 							>
// 								Cancel
// 							</button>
// 							{submitLoading ? (
// 								<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
// 									Please wait...
// 								</button>
// 							) : (
// 								<button
// 									className="ascent-button ascent-button--header-buttons ascent-button--secondary"
// 									onClick={handleSubmit}
// 									disabled={
// 										!getValue(props, `permissions`, []).includes("update") ||
// 										getValue(uploadedDocuments, `length`, 0) === 0
// 									}
// 								>
// 									{"Submit"}
// 								</button>
// 							)}
// 						</div>
// 					</div>
// 					<ModalBody>
// 						<div>
// 							<div>
// 								<div>
// 									<h6 className="comments-popup__vendor-name">Task ID</h6>
// 									<p className="comments-popup__vendor-text">
// 										{getValue(props, `vendorInfo.task_id`, "")}
// 									</p>
// 								</div>
// 								<div className="comments-popup__vendor-details">
// 									<h6 className="comments-popup__vendor-name">Legislation</h6>
// 									<p className="comments-popup__vendor-text">
// 										{getValue(
// 											props,
// 											`vendorInfo.checkpoint.legislation.legislation_name`,
// 											""
// 										)}
// 									</p>
// 								</div>
// 							</div>
// 							{/* <label className="input-file-label w-100 text-center cursor-pointer mb-4 d-flex">
// 								<input
// 									type={"file"}
// 									onChange={handleUploadDocuments}
// 									multiple
// 									className="d-none"
// 								/>
// 								<div className="custom-inputfile d-flex">
// 									<div className="custom-inputfile-margin-auto">
// 										<img src="/images/input-file.svg" className="img-fluid" />
// 										<p className="custom-inputfile__attach">
// 											Drag & Drop Files here
// 										</p>
// 										<p className="custom-inputfile__attach">OR</p>
// 										<a href="#0" className="custom-inputfile__attach">
// 											Browse Files
// 										</a>
// 									</div>
// 								</div>
// 							</label> */}
// 							<div
// 								onDrop={handleDrop}
// 								onDragOver={
// 									!uploadLoading
// 										? getValue(props, `permissions`, []).includes("update")
// 											? handleDragOver
// 											: disableUpload
// 										: disableUpload
// 								}
// 								className="mt-3"
// 							>
// 								<p className="mb-2">Files Upload{" 	"}</p>
// 								<label className="custom-file-upload-popup">
// 									{uploadLoading ? (
// 										<p>Please wait...</p>
// 									) : (
// 										<>
// 											<p className="custom-inputfile__attach">
// 												Drag & Drop Files here
// 											</p>
// 											<p className="custom-inputfile__attach">OR</p>
// 											<p className="text-primary">
// 												<p className="custom-inputfile__attach">Browse Files</p>
// 											</p>
// 										</>
// 									)}
// 									<input
// 										type="file"
// 										onChange={
// 											!uploadLoading
// 												? getValue(props, `permissions`, []).includes("update")
// 													? handleUploadDocuments
// 													: disableUpload
// 												: disableUpload
// 										}
// 										multiple
// 										className="d-none"
// 									/>
// 								</label>
// 							</div>

// 							{getValue(uploadedDocuments, `length`, 0) > 0 ? (
// 								<>
// 									{/* <h3 className="attach-files-wrapper__select">
// 										Select from uploaded files
// 									</h3> */}
// 									{uploadedDocuments.map((item: object, key: number) => {
// 										return (
// 											<div
// 												key={key}
// 												className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
// 											>
// 												<p>
// 													{getValue(item, `name`, "")}
// 													{getValue(item, `extension`, "")}
// 												</p>
// 												<div>
// 													<img
// 														src="/images/close-black.svg"
// 														className="img-fluid cursor-pointer"
// 														onClick={() =>
// 															handleRemoveUploadedFiles(
// 																getValue(item, `id`, "")
// 															)
// 														}
// 													/>
// 												</div>
// 											</div>
// 										);
// 									})}
// 								</>
// 							) : (
// 								<p className="text-center mt-2"></p>
// 							)}
// 							<div></div>
// 						</div>
// 					</ModalBody>
// 				</div>
// 				<div className="footer-wrapper d-flex justify-content-between mt-4">
// 					<img src="/images/building-illustration.svg" className="img-fluid" />
// 				</div>
// 			</Modal>
// 		</div>
// 	);
// };

// export default UploadModal;

import * as React from "react";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";
import {
	clientAuditUploadFile,
	clientUploadSubmitCheckpointLocation,
	vendorFileUpload,
	vendorUploadSubmitCheckpointLocation,
} from "@services/auth.service";
import { getValue } from "@utils/lodash";
import "./upload-modal.scss";

interface IUploadModalProps {
	isOpen: boolean;
	handleModal: () => void;
	getData: () => void;
	vendorInfo: object;
}

const UploadModal: React.FunctionComponent<IUploadModalProps> = (props) => {
	const [isLoading, setIsLoading] = React.useState(false);
	const [submitLoading, setSubmitLoading] = React.useState(false);
	const [uploadedDocuments, setUploadedDocuments] = React.useState<any>([]);

	// Function to validate file name and extension
	const validateFile = (file: File): boolean => {
		// Get the filename
		const filename = file.name.toLowerCase(); // Convert to lowercase for case-insensitive comparison
		
		// Malicious double extensions to check (add more as needed)
		const dangerousExtensions = [
			'.exe', '.bat', '.cmd', '.msi', '.vbs', '.js', '.jar', '.dll', 
			'.scr', '.com', '.pif', '.hta', '.cpl', '.msc', '.jsx'
		];
		
		// Allowed extensions (add more as needed)
		const allowedExtensions = [
			'.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv', 
			'.png', '.jpg', '.jpeg', '.gif', '.zip', '.rar', '.json',
			'.xml', '.html', '.msg', '.eml', '.rtf', '.odt', '.ods',
			'.odp', '.ppt', '.pptx'
		];
	
		// First, check if file has an allowed extension
		const hasAllowedExtension = allowedExtensions.some(ext => filename.endsWith(ext));
		if (!hasAllowedExtension) {
			toast.error(`File type not allowed. Please upload files with the following extensions: ${allowedExtensions.join(', ')}`);
			return false;
		}
	
		// Then check for dangerous double extensions
		for (const dangerous of dangerousExtensions) {
			for (const allowed of allowedExtensions) {
				// Check if filename contains a dangerous extension followed by an allowed one
				// e.g., "malicious.exe.pdf" or "file.js.xlsx"
				if (filename.includes(`${dangerous}${allowed}`)) {
					toast.error(`Security Alert: File "${file.name}" appears to have a suspicious double extension.`);
					return false;
				}
			}
		}
	
		// Additional check for any double extensions pattern
		const extensionCount = filename.split('.').length - 1;
		const lastDotIndex = filename.lastIndexOf('.');
		const secondLastDotIndex = filename.lastIndexOf('.', lastDotIndex - 1);
		
		// If there are multiple dots and they're close to each other at the end of the filename
		// e.g., "file.png.jpg" or "document.pdf.xlsx"
		if (extensionCount > 1 && secondLastDotIndex !== -1) {
			const betweenDots = filename.substring(secondLastDotIndex, lastDotIndex);
			// If the part between the last two dots looks like a file extension
			if (betweenDots.length <= 5) {  // Most extensions are 4 chars or less (.jpeg, .xlsx)
				toast.error(`File "${file.name}" appears to have multiple extensions. Please rename the file.`);
				return false;
			}
		}
	
		return true;
	};
	
		
	const handleSubmit = async () => {
		try {
			setSubmitLoading(true);
			let payload = {
				vendor_checkpoint: [
					{
						id: getValue(props, `vendorInfo.id`, ""),
						document_ids: uploadedDocuments.map((item: object) =>
							getValue(item, `id`, "")
						),
					},
				],
			};
			let resp = await clientUploadSubmitCheckpointLocation(payload);
			if (resp) {
				setSubmitLoading(false);
				props.handleModal();
				props.getData();
				toast.success("Uploaded successfully");
			} else {
				props.getData();
				setSubmitLoading(false);
			}
		} catch (error) {
			setSubmitLoading(false);
		}
	};

	const handleRemoveUploadedFiles = (id: string) => {
		let filtered = uploadedDocuments.filter(
			(item: object) => getValue(item, `id`, "") !== id
		);
		setUploadedDocuments(filtered);
	};

	const [uploadLoading, setUploadLoading] = React.useState(false);
	
	const handleUploadDocuments = async (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const files = e.target.files;
		if (!files) return;
	
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			if (!validateFile(file)) {
				continue;
			}
	
			let formData = new FormData();
			formData.append("file", file);
			
			try {
				setUploadLoading(true);
				let resp = await clientAuditUploadFile(formData);
				if (resp) {
					uploadedDocuments.push(getValue(resp, `data`, {}));
					setUploadedDocuments([...uploadedDocuments]);
					if (e.target) {
						e.target.value = "";
					}
				} else {
					if (e.target) {
						e.target.value = "";
					}
				}
			} catch (error) {
				if (e.target) {
					e.target.value = "";
				}
			} finally {
				setUploadLoading(false);
			}
		}
	};

	const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		const files = e.dataTransfer.files;
		
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			if (!validateFile(file)) {
				continue; // Skip this file if validation fails
			}

			let formData = new FormData();
			formData.append("file", file);
			
			(async () => {
				try {
					setUploadLoading(true);
					let resp = await clientAuditUploadFile(formData);
					if (resp) {
						uploadedDocuments.push(getValue(resp, `data`, {}));
						setUploadedDocuments([...uploadedDocuments]);
					}
				} catch (error) {
					console.error(error);
				} finally {
					setUploadLoading(false);
				}
			})();
		}
	};

	const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
	};
	
	const disableUpload = () => {};

	return (
		<div className="comments-popup">
			<Modal
				isOpen={getValue(props, `isOpen`, "")}
				toggle={getValue(props, `isOpen`, "")}
				centered
				size="lg"
			>
				<div className="comments-modal">
					<div className="comments-popup__header d-flex align-items-center justify-content-between mb-3">
						<h3 className="comments-popup__header-title">Attach File</h3>
						<div className="d-flex justify-content-end">
							<button
								className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
								onClick={() => props.handleModal()}
							>
								Cancel
							</button>
							{submitLoading ? (
								<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
									Please wait...
								</button>
							) : (
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--secondary"
									onClick={handleSubmit}
									disabled={
										!getValue(props, `permissions`, []).includes("update") ||
										getValue(uploadedDocuments, `length`, 0) === 0
									}
								>
									{"Submit"}
								</button>
							)}
						</div>
					</div>
					<ModalBody>
						<div>
							<div>
								<div>
									<h6 className="comments-popup__vendor-name">Task ID</h6>
									<p className="comments-popup__vendor-text">
										{getValue(props, `vendorInfo.task_id`, "")}
									</p>
								</div>
								<div className="comments-popup__vendor-details">
									<h6 className="comments-popup__vendor-name">Legislation</h6>
									<p className="comments-popup__vendor-text">
										{getValue(
											props,
											`vendorInfo.checkpoint.legislation.legislation_name`,
											""
										)}
									</p>
								</div>
							</div>
							<div
								onDrop={handleDrop}
								onDragOver={
									!uploadLoading
										? getValue(props, `permissions`, []).includes("update")
											? handleDragOver
											: disableUpload
										: disableUpload
								}
								className="mt-3"
							>
								<p className="mb-2">Files Upload{" 	"}</p>
								<label className="custom-file-upload-popup">
									{uploadLoading ? (
										<p>Please wait...</p>
									) : (
										<>
											<p className="custom-inputfile__attach">
												Drag & Drop Files here
											</p>
											<p className="custom-inputfile__attach">OR</p>
											<p className="text-primary">
												<p className="custom-inputfile__attach">Browse Files</p>
											</p>
										</>
									)}
									<input
										type="file"
										onChange={
											!uploadLoading
												? getValue(props, `permissions`, []).includes("update")
													? handleUploadDocuments
													: disableUpload
												: disableUpload
										}
										multiple
										className="d-none"
									/>
								</label>
							</div>

							{getValue(uploadedDocuments, `length`, 0) > 0 ? (
								<>
									{uploadedDocuments.map((item: object, key: number) => {
										return (
											<div
												key={key}
												className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
											>
												<p>
													{getValue(item, `name`, "")}
													{getValue(item, `extension`, "")}
												</p>
												<div>
													<img
														src="/images/close-black.svg"
														className="img-fluid cursor-pointer"
														onClick={() =>
															handleRemoveUploadedFiles(
																getValue(item, `id`, "")
															)
														}
													/>
												</div>
											</div>
										);
									})}
								</>
							) : (
								<p className="text-center mt-2"></p>
							)}
							<div></div>
						</div>
					</ModalBody>
				</div>
				<div className="footer-wrapper d-flex justify-content-between mt-4">
					<img src="/images/building-illustration.svg" className="img-fluid" />
				</div>
			</Modal>
		</div>
	);
};

export default UploadModal;